package com.nonopn.skywatcher.common.app.pages.profile

import com.nonopn.skywatcher.app.utils.Queue
import com.nonopn.skywatcher.app.utils.safeLaunch
import com.nonopn.skywatcher.app.utils.toImageBitmap
import com.nonopn.skywatcher.common.app.api.impl.ApiInterface
import eu.codlab.sentry.wrapper.Sentry
import eu.codlab.viewmodel.StateViewModel
import qrcode.QRCode
import qrcode.color.Colors

private const val Millis = 1000.0

@Suppress("TooManyFunctions")
class ProfileContentModel(
    isSystemDarkMode: Boolean,
    private val currentApi: ApiInterface,
) : StateViewModel<ProfileContentModelState>(
    ProfileContentModelState(
        isSystemDarkMode = isSystemDarkMode,
        isLoading = true,
    )
) {
    private val queue = Queue(viewModelScope)

    init {
        queue.post {
            try {
                updateState {
                    copy(
                        isLoading = true,
                        errorLoading = false
                    )
                }

                val profile = currentApi.profile()
                /*val qrCode = QRCode.ofCircles()
                    .withColor(
                        if (states.value.isSystemDarkMode) Colors.WHITE else Colors.BLACK
                    ) // Default is Colors.BLACK
                    .build(profile.uuid)*/

                updateState {
                    copy(
                        isLoading = false,
                        profile = profile,
                        // qrCode = qrCode,
                        // qrCodeImage = qrCode.renderToBytes().toImageBitmap(),
                        errorLoading = false
                    )
                }
            } catch (err: Throwable) {
                println("Error while loading the qrcode ${err.message}")
                err.printStackTrace()
                updateState {
                    copy(
                        isLoading = false,
                        errorLoading = true
                    )
                }
                Sentry.captureException(err)
            }
        }
    }

    fun updateSystemDarkMode(isSystemDarkMode: Boolean) = safeLaunch {
        queue.post {
            val qrCode = states.value.qrCode
            val profile = states.value.profile

            if (null == qrCode || null == profile) return@post

            val newQrCode = QRCode.ofCircles()
                .withColor(
                    if (isSystemDarkMode) Colors.WHITE else Colors.BLACK
                ) // Default is Colors.BLACK
                .build(profile.uuid)

            updateState {
                copy(
                    isSystemDarkMode = isSystemDarkMode,
                    qrCode = newQrCode,
                    qrCodeImage = newQrCode.renderToBytes().toImageBitmap()
                )
            }
        }
    }
}
